// Toggle the menu open and close when on mobile
export default function registerFormsEvent() {
    const sendRequestFormList = document.getElementsByName("send-request");

    async function postData(url = "", data = {}) {
        // Default options are marked with *
        return await fetch(url, {
            method: "POST",
            mode: "no-cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
            params: 'form-request',
            body: JSON.stringify(data),
        });
    }
    async function sendRequestForm(event) {
        event.preventDefault();

        const source = event.target.getAttribute('data-source')
        const data = new FormData(event.target);
        let eventName = event.target.getAttribute('data-event-name')

        if (typeof window.eventName !== 'undefined'
            && window?.eventName !== ''
        ) {
            eventName = window.eventName;
        }

        let request = {
            source: source,
            eventName: eventName,
            href: window.location.href,
            utmTags: {},
            recaptcha: ''
        };

        const utmTags = ['utm_campaign', 'utm_medium', 'utm_source', 'utm_content', 'utm_term'];
        let params = new URLSearchParams(document.location.search);

        data.forEach(function (value, key) {
            request[key] = value;
        })

        utmTags.forEach(function (tag) {
            if (params.get(tag)) {
                request.utmTags[tag] = params.get(tag);
            }
        })

        const apiUrl = 'https://n8n.sysint.net/webhook/debd5bd9-0b0f-4846-8a0b-1581feSu2iu3o';
        if (typeof window.grecaptcha !== 'undefined') {
            window.grecaptcha.ready(function() {
                window.grecaptcha.execute('6LdA0YEpAAAAAInO5z-APXmH3INo5JcVTxU7l5aa', {action: 'submit'}).then(async function (token) {
                    request.recaptcha = token;
                    await postData(apiUrl, request)
                });
            });
        } else {
            await postData(apiUrl, request)
        }

        if (source === 'form-newsletter-subscribe') {
            document.querySelector('.popup-success-container .popup-title').innerText = 'Thank you'
            document.querySelector('.popup-success-container .popup-message').innerText = 'We will send you a confirmation email'
        } else {
            document.querySelector('.popup-success-container .popup-title').innerText = 'Thank you for the request'
            document.querySelector('.popup-success-container .popup-message').innerText = 'Your message will be answered by one of the company partners the same or next business day'
        }

        if (typeof window.dataLayer !== 'undefined' && eventName) {
            window.dataLayer.push({ 'event': eventName });
        }

        if (typeof window.fbq !== 'undefined') {
            window.fbq('track', 'Lead');
        }

        window.eventName = '';

        document.body.classList.remove('popup-form-open');
        document.body.classList.add('popup-success-open');
    }

    sendRequestFormList.forEach(function (form) {
        form.addEventListener("submit", sendRequestForm)
    })
}
